export default "__VITE_ASSET__B8MYjd3D__"